import { fetchFormatTemplate } from "@/utils/sharePricePerformance/fetchFormatTemplates";
import { Format } from "@/utils/entities";

export const getRenderAgentData = async (rawData: any) => {
  const data = JSON.parse(rawData || "{}");

  const datasource = {
    percentageChangeChart: isNonEmpty(data.percentageChangeChart),
    actualTradedValueChart: !isNonEmpty(data.percentageChangeChart),
    addCustomBuiltIndices: isNonEmpty(data.customBuiltIndex),
    noCustomBuiltIndices: !isNonEmpty(data.customBuiltIndex),
    addConstantLineSelection: isNonEmpty(data.constantValueLines),
    noConstantLineSelection: !isNonEmpty(data.constantValueLines),
    addsecondaryVerticalAxisColumnChart: isNonEmpty(data.tradingVolume),
    nosecondaryVerticalAxisColumnChart: !isNonEmpty(data.tradingVolume),
    addsummaryTable: isNonEmpty(data.summaryTable),
    nosummaryTable: !isNonEmpty(data.summaryTable),
    addSmallLineChart: isNonEmpty(data.smallLineChart),
    nosmallLineChart: !isNonEmpty(data.smallLineChart),
    addCallOutBoxes: isNonEmpty(data.callOutBoxes),
    noCallOutBoxes: !isNonEmpty(data.callOutBoxes),
    addBackgroundShading: isNonEmpty(data.shadingPeriods),
    noBackgroundShading: !isNonEmpty(data.shadingPeriods),
    addVerticalLine: isNonEmpty(data.verticalLines),
    noVerticalLine: !isNonEmpty(data.verticalLines),
  };

  const formatId = data.formatId;
  const formatData: Format = await fetchFormatTemplate(formatId);

  const formatAndPlaceholderDatasource = {
    companyName: formatData?.formatName?.split("-")[0],
    templateName: formatData?.formatName?.split("-")[1],
    formatTemplateSource: data.metadata?.source,
    formatTemplateNotes: data.metadata?.notes,
  };

  const formatAndPlaceHolderData = {
    formatName: formatData?.formatName,
  };
  return {
    datasource,
    formatAndPlaceholderDatasource,
    formatAndPlaceHolderData,
  };
};

export function isNonEmpty(val) {
  if (Array.isArray(val)) return val.length > 0;
  if (val && typeof val === "object") return Object.keys(val).length > 0;
  return !!val; // For primitives
}

export const getSelectedFeature = (documentRawData) => {
  const documentData = JSON.parse(documentRawData);
  const data = {
    percentageChangeChart: isNonEmpty(documentData.percentageChangeChart),
    actualTradedValueChart: !isNonEmpty(documentData.percentageChangeChart),
    addCustomBuiltIndices: isNonEmpty(documentData.customBuiltIndex),
    noCustomBuiltIndices: !isNonEmpty(documentData.customBuiltIndex),
    addConstantLineSelection: isNonEmpty(documentData.constantValueLines),
    noConstantLineSelection: !isNonEmpty(documentData.constantValueLines),
    addsecondaryVerticalAxisColumnChart: !!documentData.tradingVolume,
    nosecondaryVerticalAxisColumnChart: !documentData.tradingVolume,
    addsummaryTable: isNonEmpty(documentData.summaryTable),
    nosummaryTable: !isNonEmpty(documentData.summaryTable),
    addSmallLineChart: isNonEmpty(documentData.smallLineChart),
    nosmallLineChart: !isNonEmpty(documentData.smallLineChart),
    addCallOutBoxes: isNonEmpty(documentData.callOutBoxes),
    noCallOutBoxes: !isNonEmpty(documentData.callOutBoxes),
    addBackgroundShading: isNonEmpty(documentData.shadingPeriods),
    noBackgroundShading: !isNonEmpty(documentData.shadingPeriods),
    addVerticalLine: isNonEmpty(documentData.verticalLines),
    noVerticalLine: !isNonEmpty(documentData.verticalLines),
  };

  return { data };
};

export function safeParse(v: any) {
  if (v == null) return {};
  if (typeof v === "string") {
    const t = v.trim();
    if (t.length === 0) return {};
    try {
      return JSON.parse(t);
    } catch {
      return {};
    }
  }
  if (typeof v === "object") return v;
  return {};
}

export const getLLMUpdatedSelectedFeature = (documentContent, llmGlobalState) => {
  const documentData = safeParse(documentContent);
  const llmGlobalStateData = safeParse(llmGlobalState);

  const data = {
    percentageChangeChart: isNonEmpty(llmGlobalStateData.percentageChangeChartForm),
    actualTradedValueChart: !isNonEmpty(llmGlobalStateData.percentageChangeChartForm),
    addCustomBuiltIndices: isNonEmpty(llmGlobalStateData.customBuiltIndicesForm),
    noCustomBuiltIndices: !isNonEmpty(llmGlobalStateData.customBuiltIndicesForm),
    addConstantLineSelection: isNonEmpty(llmGlobalStateData.constantValueLineForm),
    noConstantLineSelection: !isNonEmpty(llmGlobalStateData.constantValueLineForm),
    addsecondaryVerticalAxisColumnChart: !!documentData.tradingVolume,
    nosecondaryVerticalAxisColumnChart: !documentData.tradingVolume,
    addsummaryTable: isNonEmpty(llmGlobalStateData.summaryTableForm),
    nosummaryTable: !isNonEmpty(llmGlobalStateData.summaryTableForm),
    addSmallLineChart: isNonEmpty(llmGlobalStateData.smallLineChartForm),
    nosmallLineChart: !isNonEmpty(llmGlobalStateData.smallLineChartForm),
    addCallOutBoxes: isNonEmpty(llmGlobalStateData.callOutBoxesForm),
    noCallOutBoxes: !isNonEmpty(llmGlobalStateData.callOutBoxesForm),
    addBackgroundShading: isNonEmpty(llmGlobalStateData.backgroundShadingForm),
    noBackgroundShading: !isNonEmpty(llmGlobalStateData.backgroundShadingForm),
    addVerticalLine: isNonEmpty(llmGlobalStateData.verticalLineForm),
    noVerticalLine: !isNonEmpty(llmGlobalStateData.verticalLineForm),
  };

  return { data };
};
